var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{
  'isef-banner' : _vm.isCategories || _vm.isLanding,
  'isef-banner-shown' : _vm.showBanner
  }},[(!this.$isProduction || !_vm.isBeforeEventDate('May 4, 2024'))?_c('span',[(!_vm.isExplorer && !_vm.isHome)?_c('HomePageBanner'):_c('FinalistBanner')],1):_c('span',[(!_vm.isExplorer && !_vm.isHome)?_c('HomePageBannerDefault'):_c('FinalistBannerDefault')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }